<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head flex justify-between">
            <p class="modal-card-title">
                Provide Feedback
            </p>
        </header>
        <section class="modal-card-body">
            <d-field label="Feedback">
                <d-input v-model="form.feedback" type="textarea" />
            </d-field>
            <d-field label="Send Email">
                <d-checkbox v-model="form.sendEmail" />
            </d-field>
        </section>
        <footer class="modal-card-foot justify-end">
            <d-btn flat @click="$parent.close()">
                Cancel
            </d-btn>
            <d-btn :loading="saving" type="submit" @click="saveForm()">
                Save Changes
            </d-btn>
        </footer>
    </div>
</template>

<script>
    import { showErrorToast } from '@services/errorHandling.service';
    import { toast } from '@services/toast.service';
    import axios from 'axios';

    export default {
        emits: ['close'],
        
        props: {
            exam: {
                type: Object,
                default: () => ({}),
            }
        },

        data() {
            return {
                saving: false,
                form: {
                    feedback: '',
                    userEmail: '',
                    sendEmail: true
                },
            };
        },

        mounted() {
            this.form.userEmail = this.exam.userEmail;
            this.form.feedback = this.exam.instructorFeedback;
        },

        methods: {
            async saveForm() {
                this.saving = true;
                try {
                    await axios.post(`/api/subject-areas/content-listings/exam-reports/${this.exam.examId}/${this.exam.userId}/feedback`, this.form)
                    toast.success('Feedback saved successfully');
                    this.$emit('close');
                } catch (error) {
                    showErrorToast(error);
                } finally {
                    this.saving = false;
                }
            },
        },
    };
</script>